export const loadBrandClaims = () => ({
  http: {
    url: "/brand-claims",
  },
  types: ["LOADING_BRAND_CLAIMS", "LOAD_BRAND_CLAIMS_SUCCESS", "LOAD_BRAND_CLAIMS_FAILURE"],
});

/**
 * Get a specific claim for the current brand from the Redux store
 * @param {string} claim - The claim string in the format e.g. "sweepstakes.solo.create"
 * @returns {number|boolean|undefined} - The value of the claim for the current brand's belt
 */
export const getClaim = (claim) => {
  const { brandClaims } = store.getState();
  return brandClaims[claim];
};
